// Stripe configuration for payment processing
// Uses Stripe Connect for multi-tenant payment collection

import { loadStripe } from '@stripe/stripe-js';

// Your platform's Stripe publishable key (from your Stripe dashboard)
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
const STRIPE_PUBLISHABLE_KEY_TEST = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY_TEST || '';

// Stripe Connect Client ID (for OAuth onboarding)
const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID || 'ca_ThNLoJartxmErf5xn3fYMQK0XG2gZ0iC';

// Platform fee percentages
// Online (Card-Not-Present): Standard card payments
// Terminal (Card-Present): Lower Stripe fees for in-person
// BNPL (Afterpay/Klarna/Affirm): Financing options
export const PLATFORM_FEE_PERCENT = 1; // Legacy - for backward compatibility
export const PLATFORM_FEE_PERCENT_ONLINE = 1;    // 1% for online card payments
export const PLATFORM_FEE_PERCENT_TERMINAL = 1;  // 1% for terminal payments
export const PLATFORM_FEE_PERCENT_BNPL = 1.5;    // 1.5% for financing (Afterpay/Klarna/Affirm)

// Lazy-load Stripe
let stripePromise = null;
let stripePromiseTest = null;

export const getStripe = () => {
  if (!stripePromise && STRIPE_PUBLISHABLE_KEY !== 'pk_test_placeholder') {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

// Demo-aware Stripe loader: returns test-mode Stripe for demo accounts
export const getStripeForCompany = (isDemo = false) => {
  if (isDemo) {
    if (!stripePromiseTest && STRIPE_PUBLISHABLE_KEY_TEST) {
      stripePromiseTest = loadStripe(STRIPE_PUBLISHABLE_KEY_TEST);
    }
    return stripePromiseTest;
  }
  return getStripe();
};

// Calculate platform fee for a given amount (in cents)
// paymentType: 'online', 'terminal', or 'bnpl'
export const calculatePlatformFee = (amountCents, paymentType = 'online') => {
  const feePercent = getPlatformFeePercent(paymentType);
  return Math.round(amountCents * (feePercent / 100));
};

// Get fee percent by payment type
export const getPlatformFeePercent = (paymentType = 'online') => {
  switch (paymentType) {
    case 'terminal':
      return PLATFORM_FEE_PERCENT_TERMINAL;
    case 'bnpl':
    case 'afterpay':
    case 'klarna':
    case 'affirm':
      return PLATFORM_FEE_PERCENT_BNPL;
    default:
      return PLATFORM_FEE_PERCENT_ONLINE;
  }
};

// Format amount for display
export const formatCurrency = (cents) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);
};

// Stripe Connect OAuth URL generator
// When a company connects, they'll be redirected to this URL
export const getStripeConnectUrl = (companyId) => {
  const redirectUri = `${window.location.origin}/stripe/callback`;

  // Standard Connect onboarding
  return `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&scope=read_write&redirect_uri=${encodeURIComponent(redirectUri)}&state=${companyId}`;
};

// Check if Stripe is configured
export const isStripeConfigured = () => {
  return STRIPE_PUBLISHABLE_KEY !== 'pk_test_placeholder' && STRIPE_PUBLISHABLE_KEY.startsWith('pk_');
};
